import React from 'react';
import './About.css';

const stats = [
  { value: '4', label: 'человека в команде' },
  { value: '∞', label: 'идей в голове' },
  { value: '0', label: 'лишней бюрократии' },
];

export default function About() {
  return (
    <section className="section" id="about">
      <div className="container">
        <div className="about__grid">
          <div className="about__left reveal">
            <div className="section-label">// 001 · о проекте</div>
            <h2 className="section-title">
              Ранняя стадия —<br />
              <span className="green">максимум свободы</span>
            </h2>
            <p>
              Мы пока без MVP и первых пользователей. Зато здесь можно
              не просто исполнять задачи — а по-настоящему влиять на
              продукт, его логику и направление компании.
            </p>
            <p style={{ marginTop: '1rem', color: 'var(--text-muted)' }}>
              Всё обсуждается открыто, без формальностей.
              Мы верим, что сильный продукт рождается из честного
              разговора, а не из корпоративных процессов.
            </p>

            <div className="about__stats">
              {stats.map((s) => (
                <div key={s.value} className="about__stat">
                  <span className="about__stat-value">{s.value}</span>
                  <span className="about__stat-label">{s.label}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="about__right reveal">
            <div className="about__card">
              <div className="about__card-header">
                <span className="about__card-icon">⬡</span>
                <span>Наша цель</span>
              </div>
              <p className="about__card-body">
                Сделать агентские ИИ-системы доступными и полезными
                для каждого человека — не только для больших компаний
                с большими бюджетами.
              </p>
            </div>
            <div className="about__card">
              <div className="about__card-header">
                <span className="about__card-icon">⬡</span>
                <span>Откуда мы</span>
              </div>
              <p className="about__card-body">
                Новосибирск. Полностью удалённая команда из четырёх
                человек. Работаем из разных городов, но думаем как
                одно целое.
              </p>
            </div>
            <div className="about__card">
              <div className="about__card-header">
                <span className="about__card-icon">⬡</span>
                <span>Стадия</span>
              </div>
              <p className="about__card-body">
                Pre-MVP. Сейчас мы проектируем архитектуру продукта,
                исследуем гипотезы и собираем людей, которые хотят
                строить что-то настоящее.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
